import { Controller } from "stimulus"

export default class extends Controller {
  navigate() {
    // We can't use Turbo here as that will not reload the cached localized menus
    window.location.href = this.element.selectedOptions[0].getAttribute('data-url')
  }
}
